import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { baseApi } from "../store/api/baseApi";
import {
    consumeFinFactorJourneyPending,
    FINFACTOR_REFRESH_INTERVAL_MS,
    FINFACTOR_REFRESH_ROUNDS,
    FINFACTOR_REFRESH_TAGS,
} from "../utils/finfactorJourney.utils";

/**
 * When the user lands on the FinFactor dashboard straight after completing the
 * consent journey, refetch every FinFactor API FINFACTOR_REFRESH_ROUNDS times,
 * FINFACTOR_REFRESH_INTERVAL_MS apart (first round immediately), so the freshly
 * fetched AA data shows up without the user having to reload.
 */
export const useFinFactorJourneyRefresh = () => {
    const dispatch = useDispatch();
    const timerRef = useRef(null);

    useEffect(() => {
        if (!consumeFinFactorJourneyPending()) return undefined;

        let round = 0;

        const refreshAll = () => {
            round += 1;
            dispatch(baseApi.util.invalidateTags(FINFACTOR_REFRESH_TAGS));

            if (round >= FINFACTOR_REFRESH_ROUNDS && timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };

        refreshAll();
        timerRef.current = setInterval(refreshAll, FINFACTOR_REFRESH_INTERVAL_MS);

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [dispatch]);
};

export default useFinFactorJourneyRefresh;
